// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
// 路由
import router from './router'
//引入VUEX
import store from './vuex/store'

// 引入音频播放插件
import AudioPlayer from '@liripeng/vue-audio-player'

import {
  Autocomplete, Button, Carousel, CarouselItem, Dialog, Form, FormItem,
  Input, InputNumber, Radio, RadioGroup, Switch, Select, Option,
  Tabs, TabPane, Progress, Rate, Upload, Alert, Loading, Message, Checkbox,
  Menu, Submenu, MenuItem, Pagination, Tree, DatePicker, Popover, Tooltip, Table, TableColumn,
  Breadcrumb, BreadcrumbItem, Dropdown, DropdownMenu, DropdownItem, RadioButton, Card
} from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import MessageBox from './components/common/element-ui/packages/message-box';

import {
  ValidationObserver,
  ValidationProvider,
  extend,
  localize
} from 'vee-validate';
import zhCN from 'vee-validate/dist/locale/zh_CN.json';
import * as rules from 'vee-validate/dist/rules';
// 常量
import './common/consts'
// 指令
import Directive from './directive/index'
// 时间处理工具


Vue.use(Directive)

Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);

Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});
localize('zh_CN', zhCN);

Vue.$alert = Vue.prototype.$alert = Alert;
// 自动补全
Vue.use(Autocomplete)
// 按钮
Vue.use(Button)
// 面包屑
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
// 轮播
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Dialog)
// 表单
Vue.use(Form)
Vue.use(FormItem)
// 输入
Vue.use(Input)
Vue.use(InputNumber)
// 单选
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(RadioButton)
// 多选
Vue.use(Switch)
// 下拉列表
Vue.use(Select)
Vue.use(Option)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
// tab切换
Vue.use(Tabs)
Vue.use(TabPane)
// 进度条
Vue.use(Progress)
// 评分
Vue.use(Rate)
// 上传
Vue.use(Upload)
// 弹窗 警告
Vue.use(Alert)
// 侧边栏
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItem)
//分页
Vue.use(Pagination)
// 树形结构
Vue.use(Tree)
//选择日期
Vue.use(DatePicker)
//弹出框
Vue.use(Popover)
//文字提示
Vue.use(Tooltip)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Checkbox)
Vue.use(Card)

// 加载
Vue.use(Loading.directive)
Vue.prototype.$loading = Loading.service
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$prompt = MessageBox.prompt
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$message = Message

// 引入mint-ui
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'

Vue.use(MintUI)

// 引入vue-impress
import VueImpress from '@/components/plugin/impress';

Vue.use(VueImpress)

// 引入轮播插件
import VueAwesomeSwiper from 'vue-awesome-swiper/index.js'

Vue.use(VueAwesomeSwiper)

// 引入触摸插件 24kb
import VueTouch from 'vue-touch'

Vue.use(VueTouch, {name: 'v-touch'})

//音频播放插件
Vue.use(AudioPlayer)

// 图表
// import VCharts from 'v-charts'
// Vue.use(VCharts)

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {App}
  //render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js